<template>
  <div class="add-supporting-doc">
    <v-dialog v-model="dialog" persistent>
      <v-card elevation="4" class="px-8 py-6">
        <div class="add-supporting-doc__start-body__header d-sm-flex align-end align-content-end justify-end">
          <v-btn icon @click="$emit('close-supporting-doc-modal')">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </div>
        <div
          class="add-supporting-doc__mid-body__header d-sm-flex align-center"
          :class="{ 'text-center': breakpointXs }"
        >
          <div
            class="add-supporting-doc__mid-body__header--title fw-600"
            :class="{ 'fs-18': breakpointXs, 'fs-25': !breakpointXs }"
          >
            Select Supporting Docs
            <div class="fs-16">
              (Data from
              <span class="primary--text pointer" @click="$router.push({ name: 'dashboard.eSanchit' })">E-sanchit</span>
              tab )
            </div>
          </div>
          <v-spacer v-if="!breakpointXs"></v-spacer>
          <div class="add-supporting-doc__mid-body__header__search" :class="{ 'mr-4': !breakpointXs }">
            <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
          </div>
        </div>
        <div class="add-supporting-doc__mid-body__table mt-2">
          <v-data-table :headers="tableHeaders" :items="esanchitSupportingDocs" :search="search">
            <template v-slot:item.documentLevel="{ item }">
              <SelectField
                rules="required"
                class="supporting-doc-level my-2"
                v-model="item.documentLevel"
                :items="supportingDocLevels"
                item-text="title"
                :return-object="true"
                filled
              />
            </template>
            <template v-slot:item.action="{ item }">
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                  <v-btn
                    color="button-primary"
                    :disabled="item.attached"
                    class="info font-weight-bold"
                    dense
                    @click="attachSupportingDoc(item)"
                    >{{ item.added ? "Attached" : "Attach" }}</v-btn
                  >
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import SelectField from "@/components/SelectField";
import { SNACKBAR } from "@/store/actionTypes";
// import * as MT from "../store/mutationTypes";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
import { ATTACH_SUPPORTING_DOC_IN_EXPORT_JOB } from "../store/mutationTypes";
export default {
  name: "AddSupportingDocModal",
  components: {
    SelectField
  },
  data() {
    return {
      dialog: true,
      search: null,
      supportingDocLevel: null
    };
  },
  props: {},
  mixins: [commonMethodsMixin],
  methods: {
    attachSupportingDoc(item) {
      if (item.documentLevel === null) {
        this.$store.dispatch(SNACKBAR, {
          color: "error",
          text: "Please select Document level"
        });
        return;
      }
      // setting supporting doc similar to state by setting additional keys as null
      const supportingDoc = { ...this.$store.getters.supportingDoc };
      for (var key in supportingDoc) supportingDoc[key] = item[key];
      // todo
      supportingDoc.fileType = "PDF";
      supportingDoc.icegateId = this.$store.getters.account.icegate_id;
      supportingDoc.srNo = this.exportJobSupportingDocsLength + 1;
      supportingDoc.invoiceSrNo = 1;
      supportingDoc.itemSrNo = 1;
      if (item.documentLevel && item.documentLevel.level) {
        if (item.documentLevel.level === "item") {
          supportingDoc.itemSrNo = item.documentLevel.itemSrNo;
          supportingDoc.invoiceSrNo = item.documentLevel.invoiceSrNo;
        } else if (item.documentLevel.level === "invoice") {
          supportingDoc.invoiceSrNo = item.documentLevel.invoiceSrNo;
        }
        supportingDoc.documentLevelTitle = item.documentLevel.title;
      }
      this.$store.commit(ATTACH_SUPPORTING_DOC_IN_EXPORT_JOB, supportingDoc);
      this.$store.dispatch(SNACKBAR, {
        color: "primary",
        text: "Attached !!"
      });
      this.$forceUpdate();
      return;
    }
  },
  computed: {
    exportJobSupportingDocsLength() {
      return this.$store.getters.exportJob.supportingDocs.length;
    },
    tableHeaders() {
      return [
        { text: "Sr No.", value: "documentSrNo", align: "center" },
        { text: "Image Ref. No (IRN)", value: "imgReferenceNo", align: "center" },
        { text: "Document Type", value: "documentTypeCode", align: "center" },
        { text: "ICEGATE Filename", value: "icegateFileName", align: "center" },
        { text: "Doc Ref. No", value: "documentReferenceNo", align: "center" },
        { text: "Document Level", value: "documentLevel", align: "center" },
        { text: "Action", value: "action", align: "center" }
      ];
    },
    supportingDocLevels() {
      const jobLevel = [
        {
          title: "Job Level",
          level: "job"
        }
      ];
      const invoiceLevel = this.$store.getters.exportJob.invoices.map(invoice => {
        return {
          title: "Invoice level: " + invoice.invoiceName,
          level: "invoice",
          invoiceSrNo: invoice.invoiceSrNo
        };
      });
      const itemLevel = this.$store.getters.exportJob.items.map(item => {
        return {
          title: "Item level: " + item.ritcCode,
          level: "item",
          itemSrNo: item.itemSrNo,
          invoiceSrNo: item.invoiceSrNo
        };
      });
      return jobLevel.concat(invoiceLevel, itemLevel);
    },
    esanchitSupportingDocs() {
      return this.$store.getters.esanchitSupportingDocs.map((esanchitSupportingDoc, index) => {
        esanchitSupportingDoc.documentSrNo = index + 1;
        const addedSupportingDoc = this.$store.getters.exportJob.supportingDocs.find(
          supportingDoc => supportingDoc.imgReferenceNo === esanchitSupportingDoc.imgReferenceNo
        );
        esanchitSupportingDoc.documentLevel =
          addedSupportingDoc !== undefined ? { title: addedSupportingDoc.documentLevelTitle } : null;
        esanchitSupportingDoc.attached = addedSupportingDoc !== undefined;
        return esanchitSupportingDoc;
      });
    }
  }
};
</script>
<style lang="scss">
.add-supporting-doc {
  min-height: 350px;

  &__table {
    .v-data-table {
      background: transparent !important;
    }
  }
}
.supporting-doc-level .v-text-field__details {
  display: none !important;
}
.supporting-doc-level .v-input__slot {
  margin-bottom: 0px !important;
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}
</style>
